import AppShell from '../../components/AppShell'
import AgentCard from '../../components/AgentCard'

interface Agent {
  name: string
  description: string
  href: string
  status: string
}

interface Props {
  agents: Agent[]
}

export default function Index({ agents }: Props) {
  return (
    <AppShell>
      <section className="px-6 pt-24 pb-16 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-5xl font-bold text-gray-900 tracking-tight">
            Optimal AI Labs
          </h1>
          <p className="mt-4 text-xl text-gray-500">
            Agentic AI demos and workflow experiments from Optimal Dev Labs.
          </p>
          <p className="mt-3 text-base text-gray-400 max-w-xl mx-auto leading-relaxed">
            Explore agents that reason over documents, chain tools, and run end-to-end AI workflows—turning manual steps into repeatable, inspectable automation.
          </p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-6">
            Agents
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {agents.map(agent => (
              <AgentCard key={agent.href} {...agent} />
            ))}
          </div>
        </div>
      </section>
    </AppShell>
  )
}
